import Box from '@mui/material/Box'

export default function SettingAccountPage() {
  return (
    <Box>
      <Box>SettingAccountPage</Box>
    </Box>
  )
}
